import { Box, Stack } from "@mui/material";
import SuccessFigures from "./SuccessFigures";
import Marquee from "react-fast-marquee";

const MarketingComponent = () => {
  return (
    <Box
    // display={{ sm: "none" }}
    // width={{xs:"375px", md:"1400px" }}
    >
      <Box
        sx={{
          display: { md: "flex", sm: "flex", xs: "flex" },
          height: "100%",
          justifyContent: "center",
          // border: "2px solid red",
        }}
        bgcolor={"#F7F7F7"}
        paddingLeft={{ md: 7, sm: 7, xs: 7 }}
        paddingRight={{ md: 7, sm: 7, xs: 7 }}
        padding={5}
      >
        <Box
          width={"100%"}
          overflow={"scroll"}
          // sx={{ border: "2px solid blue" }}
        >
          <Marquee>
            <Stack
              direction={{ md: "row", xs: "row" }}
              spacing={{ md: 25, sm: 20, xs: 6 }}
              paddingY={2}
              justifyContent={"center"}
              // bgcolor={"blue"}
            >
              {/* <SuccessFigures
                label="Satisfied users"
                topText="5,000+"
                textColor="primary"
              /> */}
              <SuccessFigures
                label="Satisfied merchants"
                topText="036+"
                textColor="primary"
              />
              <SuccessFigures
                label="Successful transactions"
                topText="0.4k"
                textColor="secondary"
              />
              <SuccessFigures
                label="Satisfied payment"
                topText="$0.5m"
                textColor="primary"
              />
              <SuccessFigures
                label="Satisfied merchants"
                topText="036+"
                textColor="primary"
              />
              <SuccessFigures
                label="Successful transactions"
                topText="0.4k"
                textColor="secondary"
              />
              <SuccessFigures
                label="Satisfied payment"
                topText="$0.5m"
                textColor="primary"
              />
              <SuccessFigures
                label="Satisfied merchants"
                topText="036+"
                textColor="primary"
              />
              <SuccessFigures
                label="Successful transactions"
                topText="0.4k"
                textColor="secondary"
              />
              <Box paddingRight={20}>
                <SuccessFigures
                  label="Satisfied payment"
                  topText="$0.5m"
                  textColor="primary"
                />
              </Box>
            </Stack>
          </Marquee>
        </Box>
      </Box>
    </Box>
  );
};

export default MarketingComponent;
